import React from 'react';
import { useNavigate } from "react-router-dom";
import PageLevelChecks from './PageLevelChecks';
import useBatchUrlAnalysisProcessesPolling from '../process/hooks/useBatchUrlAnalysisProcessesPolling';
import useGetFailedChecksForCluster from './hooks/useGetFailedChecksForCluster';


type Props = {
    websiteGuid: string;
    clusterGuid: string;
    urlsInCluster?: number;
};


export default function ClusterFailedChecks({ websiteGuid, clusterGuid, urlsInCluster }: Props) {
    const navigate = useNavigate();

    const { isRunningBatchAnalysis } = useBatchUrlAnalysisProcessesPolling(websiteGuid);

    const { failedChecksWithDetails, isLoading: isLoadingFailedChecks } = useGetFailedChecksForCluster({
        websiteGuid,
        clusterGuid,
        totalUrlsInCluster: urlsInCluster,
        shouldRefetchOnMount: isRunningBatchAnalysis,
    });

    const handleFailedCheckButtonClick = (seoTestKey: string) => {
        navigate(`/deep-analysis/failed-check/${seoTestKey}?w_guid=${websiteGuid}&cluster_guid=${clusterGuid}`);
    };

    return (
        <PageLevelChecks
            title="Page Group failed checks"
            type="cluster"
            failedChecks={failedChecksWithDetails}
            isLoading={isLoadingFailedChecks}
            isRunningBatchAnalysis={isRunningBatchAnalysis}
            onFailedCheckButtonClicked={handleFailedCheckButtonClick}
            totalUrlsCount={urlsInCluster}
        />
    );
}
